import * as Types from '../../types';

import { gql } from '@apollo/client';
import { AddressDisplayFragmentDoc } from '../../components/AddressDisplay/AddressDisplay.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDecodedEventsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;

export type GetDecodedEventsQuery = {
  __typename?: 'Query';
  decodedEvents: {
    __typename?: 'DecodedEventConnection';
    edges: Array<{
      __typename?: 'DecodedEventEdge';
      cursor: string;
      node: {
        __typename?: 'DecodedEvent';
        id: any;
        eventName: string;
        eventSignature: string;
        decodedData: any;
        createdAt: any;
        log?: {
          __typename?: 'Log';
          id: any;
          transactionHash: string;
          blockNumber: number;
          logIndex: number;
          address: {
            __typename?: 'Address';
            address: string;
            entity?: {
              __typename?: 'Entity';
              id: any;
              name: string;
              risks: {
                __typename?: 'EntityRiskConnection';
                totalCount: number;
                pageInfo: {
                  __typename?: 'PageInfo';
                  hasNextPage: boolean;
                  hasPreviousPage: boolean;
                  startCursor?: string | null;
                  endCursor?: string | null;
                };
                edges: Array<{
                  __typename?: 'EntityRiskEdge';
                  node: {
                    __typename?: 'EntityRisk';
                    id: any;
                    riskType: string;
                    severity: string;
                    description?: string | null;
                  };
                }>;
              };
            } | null;
            risks: {
              __typename?: 'AddressRiskConnection';
              totalCount: number;
              pageInfo: {
                __typename?: 'PageInfo';
                hasNextPage: boolean;
                hasPreviousPage: boolean;
                startCursor?: string | null;
                endCursor?: string | null;
              };
              edges: Array<{
                __typename?: 'AddressRiskEdge';
                node: {
                  __typename?: 'AddressRisk';
                  id: any;
                  riskType: string;
                  severity: string;
                  description?: string | null;
                };
              }>;
            };
          };
        } | null;
      };
    }>;
    pageInfo: {
      __typename?: 'PageInfo';
      hasNextPage: boolean;
      hasPreviousPage: boolean;
      startCursor?: string | null;
      endCursor?: string | null;
    };
    totalCount: number;
  };
};

export const GetDecodedEventsDocument = gql`
  query GetDecodedEvents(
    $after: String
    $before: String
    $first: Int
    $last: Int
  ) {
    decodedEvents(after: $after, before: $before, first: $first, last: $last) {
      edges {
        node {
          id
          eventName
          eventSignature
          decodedData
          createdAt
          log {
            id
            transactionHash
            blockNumber
            address {
              ...AddressDisplay
            }
            logIndex
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
  ${AddressDisplayFragmentDoc}
`;

/**
 * __useGetDecodedEventsQuery__
 *
 * To run a query within a React component, call `useGetDecodedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDecodedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDecodedEventsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useGetDecodedEventsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetDecodedEventsQuery,
    GetDecodedEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetDecodedEventsQuery, GetDecodedEventsQueryVariables>(
    GetDecodedEventsDocument,
    options,
  );
}
export function useGetDecodedEventsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetDecodedEventsQuery,
    GetDecodedEventsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetDecodedEventsQuery,
    GetDecodedEventsQueryVariables
  >(GetDecodedEventsDocument, options);
}
export function useGetDecodedEventsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetDecodedEventsQuery,
        GetDecodedEventsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetDecodedEventsQuery,
    GetDecodedEventsQueryVariables
  >(GetDecodedEventsDocument, options);
}
export type GetDecodedEventsQueryHookResult = ReturnType<
  typeof useGetDecodedEventsQuery
>;
export type GetDecodedEventsLazyQueryHookResult = ReturnType<
  typeof useGetDecodedEventsLazyQuery
>;
export type GetDecodedEventsSuspenseQueryHookResult = ReturnType<
  typeof useGetDecodedEventsSuspenseQuery
>;
export type GetDecodedEventsQueryResult = Apollo.QueryResult<
  GetDecodedEventsQuery,
  GetDecodedEventsQueryVariables
>;
